import { render, staticRenderFns } from "./SearchFrom.vue?vue&type=template&id=efb848f8&"
import script from "./SearchFrom.vue?vue&type=script&lang=js&"
export * from "./SearchFrom.vue?vue&type=script&lang=js&"
import style0 from "./SearchFrom.vue?vue&type=style&index=0&id=efb848f8&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports